import React from 'react';
import useWindowSize from '../../hooks/useWindowSize';
import { Link } from 'react-router-dom';

const FooterHome = () => {
    const size = useWindowSize();
    return(
        <div className="c-footerHome">
            <div className="c-footerHome__link">
                <div className="c-footerHome__row w-2">
                    <h1 className="c-sidebar__logo footer">
                        <a href={'/'}>  
                        </a> 
                    </h1> 
                    <span className='c-footerHome_sologun'>Future of decentralized <br/> & crowdfunding platform</span>
                </div>
                <div className="c-footerHome__row">
                    <p>Product</p>
                    <ul>
                        <li><a href="https://kingdomstarter.io/launchpad/completed" target="_blank" rel="noopener noreferrer">IDO Launchpad</a></li>
                        <li><a href="https://kingdomstarter.io/ino/ended" target="_blank" rel="noopener noreferrer">INO Launchpad</a></li>
                        <li><a href="https://kingdomstarter.io/airdrop/completed" target="_blank" rel="noopener noreferrer">Airdrop Portal</a></li>
                        <li><a href="https://kingdomstarter.io/gamehub" target="_blank" rel="noopener noreferrer">Gamehub</a></li>
                    </ul>
                </div>
                <div className="c-footerHome__row">
                    <p>Resources</p>
                    <ul>
                        <li><a href="https://kingdomstarter.medium.com/" target="_blank" rel="noopener noreferrer">Blog</a></li>
                        <li><a rel="noopener noreferrer">FAQ</a></li>
                        <li><a href="https://docs.kingdomstarter.io/" target="_blank" rel="noopener noreferrer">Documents</a></li>
                    </ul>
                </div>
                <div className="c-footerHome__row">
                    <p>Social</p>
                    <ul>
                        <li><a href="https://twitter.com/Kingdomstarter" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                        <li><a href="https://t.me/kdg_ann" target="_blank" rel="noopener noreferrer">Telegram</a></li>
                        <li><a href="https://www.facebook.com/KingdomStarter" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                        <li><a href="https://www.youtube.com/channel/UCl7ezf4kJUxjlPJwaoPtapA" target="_blank" rel="noopener noreferrer">Youtube</a></li>
                    </ul>
                </div>
                 <div className="c-footerHome__row">
                    <p>Legal</p>
                    <ul>
                        <li><Link to={'/terms'}>Terms</Link></li> 
                        <li><Link to={'/privacy'}>Privacy</Link></li> 
                        <li><Link to={'/cookies'}>Cookies</Link></li>  
                    </ul>
                </div>
            </div>
            <p className="c-footerHome__copy">Copyright © 2023 Kingdomstarter.io{size.width >= 767 ? ' ' : <><br/></>}All Rights Reserved</p>
        </div>
    )
}

export default FooterHome;